import { SET_COUNTRY } from "../actionTypes";

const initialState = "";

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_COUNTRY: {
      return action.payload;
    }
    default:
      return state;
  }
};
